var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Responses403 } from "@consta/gpn-responses/Responses403";
import { Responses404 } from "@consta/gpn-responses/Responses404";
import { Responses500 } from "@consta/gpn-responses/Responses500";
import { useNavigate, useRouteError } from "react-router";
import styles from "./RoutingErrorPage.module.scss";
import { Button } from "@consta/uikit/Button";
import { HTTP_ERRORS_VALUES } from "../../../shared/enums/errors-type-values";
import { PATHS_VALUES } from "../../../shared/enums/routing-paths-values";
var RoutingErrorPage = function () {
    var error = useRouteError();
    console.error(error);
    var navigate = useNavigate();
    function getError404Page() {
        return (_jsx(Responses404, { actions: _jsx("div", __assign({ className: styles.actions }, { children: _jsx(Button, { size: "m", view: "ghost", label: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443", onClick: function () { return navigate(PATHS_VALUES.STARTING_PAGE); } }) })) }));
    }
    function getError500Page() {
        return _jsx(Responses500, {});
    }
    function getError403Page() {
        return (_jsx(Responses403, { actions: _jsx("div", __assign({ className: styles.actions }, { children: _jsx(Button, { size: "m", view: "ghost", label: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443", onClick: function () { return navigate(PATHS_VALUES.DIAGRAMS_PAGE); } }) })) }));
    }
    function getResponseByStatucCode(statusCode) {
        switch (statusCode) {
            case HTTP_ERRORS_VALUES.ERROR_403:
                return getError403Page();
            case HTTP_ERRORS_VALUES.ERROR_404:
                return getError404Page();
            default:
                return getError500Page();
        }
    }
    return (_jsx("div", __assign({ className: styles.errorPage }, { children: getResponseByStatucCode(error.status) })));
};
export default RoutingErrorPage;
